"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormFieldDateRange = exports.className = void 0;
const moment_1 = __importDefault(require("moment"));
const react_1 = __importStar(require("react"));
const classFunctions_1 = require("../../../../utils/classFunctions");
const format_1 = require("../../../../utils/dateTime/format");
const validation_1 = require("../../../../utils/dateTime/validation");
const dateTimeFormat_1 = require("../../../../utils/dateTimeFormat");
const mobilePlatform_1 = require("../../../../utils/mobilePlatform");
const Range_1 = require("../../../Date/Range");
const Date_1 = require("../Date");
const useLazyValue_1 = require("../Date/useLazyValue");
const index_1 = require("../index");
const useOutDateRangeClick_1 = require("./useOutDateRangeClick");
require("./index.scss");
exports.className = 'form-field-date-range';
const sameOutputDateRange = (x, y) => {
    return (0, Date_1.sameOutputDate)(x.from, y.from) && (0, Date_1.sameOutputDate)(x.to, y.to);
};
/** @deprecated Use FormFieldDateRangeStable */
const FormFieldDateRange = (props) => {
    var _a, _b;
    const { fromField, toField, restrictions, calendarView = 'auto', onBlur = () => { }, modificators, } = props;
    const propsValue = {
        from: fromField.value,
        to: toField.value,
    };
    const onChange = (date) => {
        fromField.setValue(date.from);
        // To split react setState for different fields in single form.
        setTimeout(() => toField.setValue(date.to), 0);
    };
    const [lazyValue, onLazyChange] = (0, useLazyValue_1.useLazyValue)(propsValue, onChange, sameOutputDateRange);
    const [dateRangeText, setDateRangeText] = (0, react_1.useState)((0, format_1.mapToInputDateRange)(lazyValue));
    (0, react_1.useEffect)(() => {
        setDateRangeText((0, format_1.mapToInputDateRange)(lazyValue));
    }, [lazyValue]);
    const [isOpenDatePicker, setIsOpenPicker] = (0, react_1.useState)(false);
    const [dateClickInitBy, setDateClickInitBy] = (0, react_1.useState)('from');
    const [dateRangeErrors, setDateRangeErrors] = (0, react_1.useState)({});
    (0, react_1.useEffect)(() => {
        setDateRangeErrors((0, validation_1.validateDateRange)(dateRangeText, restrictions, true));
    }, [dateRangeText, restrictions]);
    const updateState = (input, isBlur) => {
        const output = (0, format_1.mapToOutputDateRange)(input);
        onLazyChange(output);
        if (isBlur) {
            setIsOpenPicker(false);
            onBlur(output);
        }
        const newDateRange = isBlur ? (0, format_1.standardizeInputDateRange)(input) : input;
        setDateRangeText(newDateRange);
    };
    const openDatePicker = (initBy) => {
        setDateClickInitBy(initBy);
        setIsOpenPicker(true);
    };
    const { rootRef } = (0, useOutDateRangeClick_1.useOutDateRangeClick)(() => {
        updateState(dateRangeText, true);
    });
    const isMobile = (0, mobilePlatform_1.checkMobilePlatform)();
    const fromFieldProps = {
        onChange: (e) => {
            const range = {
                from: e.target.value,
                to: dateRangeText.to,
            };
            updateState(range, false);
        },
        onFocus: () => {
            openDatePicker('from');
        },
        value: (_a = dateRangeText.from) !== null && _a !== void 0 ? _a : '',
        error: [dateRangeErrors.from, fromField.error],
        modificators: fromField.modificators,
        required: fromField.required,
        addonIcon: 'calendar',
        autoComplete: 'off',
        placeholder: (0, moment_1.default)().format(dateTimeFormat_1.DATE_FORMAT),
        label: fromField.label,
        name: fromField.name,
        inputMode: isMobile ? 'none' : 'text',
        disabled: fromField.disabled,
    };
    const toFieldProps = {
        onChange: (e) => {
            const range = {
                from: dateRangeText.from,
                to: e.target.value,
            };
            updateState(range, false);
        },
        onFocus: () => {
            openDatePicker('to');
        },
        value: (_b = dateRangeText.to) !== null && _b !== void 0 ? _b : '',
        error: [dateRangeErrors.to, toField.error],
        modificators: toField.modificators,
        required: toField.required,
        addonIcon: 'calendar',
        autoComplete: 'off',
        placeholder: (0, moment_1.default)().add(1, 'day').format(dateTimeFormat_1.DATE_FORMAT),
        label: toField.label,
        name: toField.name,
        inputMode: isMobile ? 'none' : 'text',
        disabled: toField.disabled,
    };
    const pickerDateRangeProps = {
        restrictions,
        dateClickInitBy,
        dateRange: dateRangeText,
        isEffectCloseAfterSelectActive: true,
        onDateRangeChange: (range, initBy) => {
            setDateClickInitBy(initBy || 'from');
            updateState(range, false);
        },
        onClose: (range) => {
            updateState(range, true);
        },
    };
    const classNames = (0, classFunctions_1.getClassNames)(exports.className, [
        modificators,
    ]);
    const calendarClassNames = (0, classFunctions_1.getClassNames)(`${exports.className}__calendar`, [
        calendarView === 'horizontal' ? 'horizontal' : undefined,
        calendarView === 'vertical' ? 'vertical' : undefined,
    ]);
    return (react_1.default.createElement("div", { className: classNames, ref: rootRef },
        react_1.default.createElement(index_1.FormField, { ...fromFieldProps }),
        react_1.default.createElement(index_1.FormField, { ...toFieldProps }),
        react_1.default.createElement("div", { className: calendarClassNames }, isOpenDatePicker && react_1.default.createElement(Range_1.InputDateRange, { ...pickerDateRangeProps }))));
};
exports.FormFieldDateRange = FormFieldDateRange;
//# sourceMappingURL=index.js.map